/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/prefer-includes */
declare global {
  interface Window {
    heap: any;
  }
}

export function init(): void {
  const heapAppId = (): number => {
    const PROD_ID = 1541779433;
    const STAGING_ID = 1235643299;
    const DEV_ID = 3622852624;
    try {
      const prodDomain = /helix\-builder\.helix\.com/;
      if (prodDomain.test(window.location.hostname)) {
        return PROD_ID;
      }

      const stgDomain = /helix\-builder\.staging\.helix\.com/;
      return stgDomain.test(window.location.hostname) ? STAGING_ID : DEV_ID;
    } catch (e) {
      return DEV_ID;
    }
  };
  // eslint-disable-next-line
  (window.heap = window.heap || []),
    (window.heap.load = function (e: any, t: any) {
      window.heap.appid = e;
      window.heap.config = t = t || {};
      const r = t.forceSSL || document.location.protocol === 'https:';
      const a = document.createElement('script');
      a.type = 'text/javascript';
      a.async = !0;
      a.src = (r ? 'https:' : 'http:') + '//cdn.heapanalytics.com/js/heap-' + e + '.js';
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const n = document.getElementsByTagName('script')[0]!;
      n.parentNode?.insertBefore(a, n);
      for (
        let o = function (e: any) {
            return function () {
              // eslint-disable-next-line
              window.heap && window.heap.push && window.heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
          },
          p = [
            'addEventProperties',
            'addUserProperties',
            'clearEventProperties',
            'identify',
            'resetIdentity',
            'removeEventProperty',
            'setEventProperties',
            'track',
            'unsetEventProperty',
          ],
          c = 0;
        c < p.length;
        c++
      )
        window.heap[p[c]] = o(p[c]);
    });
  window.heap.load(heapAppId());
}

export function identifyOrganization(organizationName: string): void {
  if (window.heap?.addUserProperties) {
    window.heap.addUserProperties({ OrganizationName: organizationName });
  }
}

export interface EventProperties {
  [key: string]: number | string;
}

export function trackError(event: string, properties?: EventProperties): void {
  if (window.heap?.track) {
    window.heap.track(event, properties);
  }
}
